import axios from '@/libs/api.request'

const openAppPrefix = '/print/tmall/open-app'

export const GetTmallOpenAppList = params => {
  return axios.request({
    url: `${openAppPrefix}/list`,
    params,
    method: 'get'
  })
}

export const GetTmallOpenAppInfo = params => {
  return axios.request({
    url: `${openAppPrefix}/info`,
    params,
    method: 'get'
  })
}

export const SaveTmallOpenApp = data => {
  return axios.request({
    url: `${openAppPrefix}/save`,
    data,
    method: 'post'
  })
}

export const ResetTmallOpenAppKey = data => {
  return axios.request({
    url: `${openAppPrefix}/reset-key`,
    data,
    method: 'post'
  })
}

export const GetTmallAgentApi = params => {
  return axios.request({
    url: '/print/tmall/agent-api',
    params,
    method: 'get'
  })
}

export const SaveTmallAgentApi = data => {
  return axios.request({
    url: '/print/tmall/agent-api',
    data,
    method: 'post'
  })
}
